var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsDateString, IsEnum, IsNumber, IsObject, IsOptional, IsString, IsUUID, } from 'class-validator';
import { Role } from '../../roles/enums/role.enum.js';
import { UserProfileDto } from '../../user/dto/user.profile.dto.js';
import { TreatmentLocation } from '../enums/treatment-location.enum.js';
import { CallPatientResponseDto } from './call-patient.response.dto.js';
/**
 * Response DTO for Call queries. Status counters (declines, acceptations, …)
 * are plain fields populated by `CallResponseMapper` from the linked
 * `appointment.participants` — not derived on the fly from `callPatients`
 * since CallPatient no longer carries acknowledgement status.
 */
export class CallResponseDto {
    id;
    createdAt;
    updatedAt;
    /** @deprecated Use the linked Appointment's therapistId instead. */
    therapistId;
    /** @deprecated Use the linked Appointment's scheduledStart instead. */
    scheduledStart;
    /** @deprecated Use the linked Appointment's service instead. */
    service;
    /** @deprecated Use the linked Appointment's description instead. */
    description;
    /** @deprecated Use the linked Appointment's plannedDuration instead. */
    plannedDuration;
    isCanceled;
    isInitialized;
    initializationTime;
    hasEnded;
    /** @deprecated Use the linked Appointment's treatmentLocation instead. */
    treatmentLocation;
    callPatients;
    therapist;
    /** @deprecated Use the linked Appointment's officeLocationId instead. */
    officeLocationId;
    archiveDownloadTimestamp;
    expiresInDays;
    endedByTherapistOn;
    /** @deprecated Use the linked Appointment's officeProductAssignmentId instead. */
    officeProductAssignmentId;
    appointmentId;
    declines = 0;
    isDeclined = false;
    acceptations = 0;
    isAccepted = false;
    isPartiallyAccepted = false;
    pendings = 0;
    isPending = false;
    // Computed properties that don't depend on status
    get therapistOfficeId() {
        return this.therapist?.officeId;
    }
    get patientIds() {
        return this.callPatients
            ? this.callPatients.map((callPatient) => callPatient?.patient?.id || '')
            : [];
    }
    get totalPatients() {
        return this.callPatients?.length || 0;
    }
    get isDone() {
        return this.scheduledStart < new Date();
    }
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], CallResponseDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], CallResponseDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], CallResponseDto.prototype, "updatedAt", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], CallResponseDto.prototype, "therapistId", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], CallResponseDto.prototype, "scheduledStart", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], CallResponseDto.prototype, "service", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], CallResponseDto.prototype, "description", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], CallResponseDto.prototype, "plannedDuration", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Boolean)
], CallResponseDto.prototype, "isCanceled", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Boolean)
], CallResponseDto.prototype, "isInitialized", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], CallResponseDto.prototype, "initializationTime", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Boolean)
], CallResponseDto.prototype, "hasEnded", void 0);
__decorate([
    IsEnum(TreatmentLocation),
    Expose(),
    __metadata("design:type", String)
], CallResponseDto.prototype, "treatmentLocation", void 0);
__decorate([
    IsArray(),
    Type(() => CallPatientResponseDto),
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT, Role.THERAPIST] }),
    __metadata("design:type", Array)
], CallResponseDto.prototype, "callPatients", void 0);
__decorate([
    IsOptional(),
    IsObject(),
    Type(() => UserProfileDto),
    Expose(),
    __metadata("design:type", Object)
], CallResponseDto.prototype, "therapist", void 0);
__decorate([
    IsOptional(),
    IsUUID(),
    Expose(),
    __metadata("design:type", Object)
], CallResponseDto.prototype, "officeLocationId", void 0);
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", Object)
], CallResponseDto.prototype, "archiveDownloadTimestamp", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], CallResponseDto.prototype, "expiresInDays", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    IsOptional(),
    __metadata("design:type", Object)
], CallResponseDto.prototype, "endedByTherapistOn", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], CallResponseDto.prototype, "officeProductAssignmentId", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], CallResponseDto.prototype, "appointmentId", void 0);
__decorate([
    IsNumber(),
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT, Role.THERAPIST] }),
    __metadata("design:type", Number)
], CallResponseDto.prototype, "declines", void 0);
__decorate([
    IsBoolean(),
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT, Role.THERAPIST] }),
    __metadata("design:type", Boolean)
], CallResponseDto.prototype, "isDeclined", void 0);
__decorate([
    IsNumber(),
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT, Role.THERAPIST] }),
    __metadata("design:type", Number)
], CallResponseDto.prototype, "acceptations", void 0);
__decorate([
    IsBoolean(),
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT, Role.THERAPIST] }),
    __metadata("design:type", Boolean)
], CallResponseDto.prototype, "isAccepted", void 0);
__decorate([
    IsBoolean(),
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT, Role.THERAPIST] }),
    __metadata("design:type", Boolean)
], CallResponseDto.prototype, "isPartiallyAccepted", void 0);
__decorate([
    IsNumber(),
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT, Role.THERAPIST] }),
    __metadata("design:type", Number)
], CallResponseDto.prototype, "pendings", void 0);
__decorate([
    IsBoolean(),
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT, Role.THERAPIST] }),
    __metadata("design:type", Boolean)
], CallResponseDto.prototype, "isPending", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT, Role.THERAPIST] }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], CallResponseDto.prototype, "therapistOfficeId", null);
__decorate([
    IsArray(),
    IsString({ each: true }),
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT, Role.THERAPIST] }),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], CallResponseDto.prototype, "patientIds", null);
__decorate([
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT, Role.THERAPIST] }),
    IsNumber(),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [])
], CallResponseDto.prototype, "totalPatients", null);
__decorate([
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT, Role.THERAPIST] }),
    IsBoolean(),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], CallResponseDto.prototype, "isDone", null);
//# sourceMappingURL=call.response.dto.js.map